export enum EDayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6
}

export enum EPayCalendarTypes {
    Weekly = 0,
    Biweekly = 1,
    Monthly = 2,
    SemiMonthly = 3
}

export interface IPaySettings {
    MaximumPunchSetLength: number
    PayPeriodStartDay: EDayOfWeek
    PayPeriodDayStartTime24Hour: number
    SplitPunchAtDayStart: boolean
    PayPeriodNumberOfWeeks?: number
    TimecardExportCSVHeaderContent?: string
    TimecardExportCSVJSRowCalculator?: string
    PayCalendarType: EPayCalendarTypes
    PayCalendarStartDate: Date | string
    PayCalendarMonthlyPayDay1: number
    PayCalendarMonthlyPayDay2: number
    OvertimeSettings: IOvertimeSettings
}

export interface IOvertimeSettings {
    RegularTimePayTypeId?: string
    OverTimePayTypeId?: string
    DoubleOverTimePayTypeId?: string
    RegularTimePayClassId?: string
    OverTimePayClassId?: string
    DoubleOverTimeClassTypeId?: string
    OvertimeRules: IOvertimeRule[]
    OrderOfPriority?: string[]
}

export interface IOvertimeRule {
    Id: string
    Type: EOvertimeRuleType
    OvertimeHourThreshold: number
    EnableDoubleOvertime: boolean
    DoubleOvertimeHourThreshold: number
    OvertimePayTypeId?: string
    DoubleOvertimePayTypeId?: string
    ConsecutiveDaysSettings: IConsecutiveDaysSettings
    OvertimeThresholdInMinutes?: number
    DoubleOvertimeThresholdInMinutes?: number
    PayTypeIdOvertimePriorityList?: string[]
}

export interface IConsecutiveDaysSettings {
    DaysWorkedToTriggerOvertime: number
}

export enum EOvertimeRuleType {
    Daily = 0,
    Weekly = 1,
    ConsecutiveDay = 2,
    Bi_Weekly = 3
}